<mat-icon
  class="custom-icon"
  [matTooltip]="content"
  [matTooltipPosition]="position"
  [matTooltipHideDelay]="delay"
></mat-icon>
